// src/components/AvatarSelectionModal.js
import React from 'react';
import { db } from '../firebase';
import { doc, updateDoc, deleteField } from 'firebase/firestore';

// Defines the list of available files in your public/avatars folder
const AVATAR_OPTIONS = [
  '1.png', '2.png', '3.png', '4.png', '5.png', '6.png'
];

const AvatarSelectionModal = ({ user, onClose }) => {

  const handleSelectAvatar = async (filename) => {
    try {
      const userDocRef = doc(db, 'users', user.uid);
      await updateDoc(userDocRef, {
        avatarImage: filename // Save just the filename
      });
      onClose();
    } catch (error) {
      console.error("Error updating avatar:", error);
    }
  };

  const handleRemoveAvatar = async () => {
    try {
      const userDocRef = doc(db, 'users', user.uid);
      await updateDoc(userDocRef, {
        avatarImage: deleteField() // Remove the field to revert to letter
      });
      onClose();
    } catch (error) {
      console.error("Error removing avatar:", error);
    }
  };

  return (
    <div className="avatar-picker-container">
      <p>Select an avatar to display instead of your initial.</p>
      
      <div className="avatar-grid">
        {AVATAR_OPTIONS.map((filename) => (
          <button 
            key={filename} 
            className="avatar-option-btn"
            onClick={() => handleSelectAvatar(filename)}
          >
            {/* This loads the image directly from the public folder */}
            <img src={`/avatars/${filename}`} alt="avatar option" />
          </button>
        ))}
      </div>

      <div className="modal-actions">
        <button className="remove-btn" onClick={handleRemoveAvatar}>
          Use Default Letter
        </button>
      </div>
    </div>
  );
};

export default AvatarSelectionModal;